module.exports = __webpack_public_path__ + "img/CarenSchwartz.1e42ece8.jpg";